import { render, staticRenderFns } from "./my-invoice-history-details.vue?vue&type=template&id=46a2284a&"
import script from "./my-invoice-history-details.vue?vue&type=script&lang=js&"
export * from "./my-invoice-history-details.vue?vue&type=script&lang=js&"
import style0 from "./my-invoice-history-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports